__turbopack_context__.v({
  "border--none": "Tx-efa_border--none",
  "button": "Tx-efa_button",
  "colorScheme--neutral": "Tx-efa_colorScheme--neutral",
  "container": "Tx-efa_container",
  "disabled": "Tx-efa_disabled",
  "isSelected": "Tx-efa_isSelected",
  "item": "Tx-efa_item",
  "list": "Tx-efa_list",
  "size--sm": "Tx-efa_size--sm",
  "textStyle--heading": "Tx-efa_textStyle--heading",
  "width--maxcontent": "Tx-efa_width--maxcontent",
});
